<template>
  <div class="products-management-page">
    <custom-tabs
      v-model="activeTab"
      :tab-items="tabs"
      class="mx-2 my-4 "
      grow
    >
      <template #staticItems>
        <!-- تب اول: محصولات فعال -->
        <v-tab-item>
          <WooVariantsListTab :store_id="store_id"/>
        </v-tab-item>
        <v-tab-item>
          <WooVariantsListDeactvieTab :store_id="store_id" />
        </v-tab-item>

        <v-tab-item>
          <WooVariantsListArchiveTab :store_id="store_id" />
        </v-tab-item>

      </template>
    </custom-tabs>
  </div>
</template>

<script>
import { integer, numeric } from "vuelidate/lib/validators";
import WooVariantsListArchiveTab from "./WooVariantsListArchiveTab.vue";
import WooVariantsListDeactvieTab from "./WooVariantsListDeactvieTab.vue";
import WooVariantsListTab from "./WooVariantsListTab.vue";

export default {
  name: "productList",
  components: {
    WooVariantsListArchiveTab,
    WooVariantsListDeactvieTab,
    WooVariantsListTab
  },
  props:{
    store_id:{type:Number, default:null}
  },
  data() {
    return {
      activeTab: 0,
      tabs: [
        {
          text: "لیست تنوع فعال",
          icon: "format-list-bulleted",
        },
        {
          text: "لیست تنوع غیرفعال",
          icon: "format-list-bulleted",
        },
        {
          text: "آرشیو تنوع",
          icon: "archive",
        },
         
      ],
    };
  },
};
</script>
